import * as angular from 'angular';

import Colors from './colors.service';
import NumberToPositiveNegativeClassFilter from './numberToPositiveNegativeClass.filter';

export default angular
  .module('styleguide', [])
  .service('colors', Colors)
  .filter('numberToPositiveNegativeClass', NumberToPositiveNegativeClassFilter)
  .name;
